module.exports = __webpack_public_path__ + "static/img/2009.6f86f650.jpg";